import { PagedResult } from './PagedResult';
import { QueryModel } from './queryModel';

export class PagingModel {
  responseData: PagedResult;
  responseObj: any[];
  query = new QueryModel();
  pager: number[];
  currentPage = 1;
  totalPages: number;
  sortedBy: string = 'id';
  sortDirection: string = 'des';
}
